import store from "@/store";
// import moment from "moment";
// import { app } from "@/main.js";

export default (to, from, next) => {
	// let serverHost = app.config.globalProperties.$config.getServerHost().toString();

	// let currentTime = new Date().toISOString();
	// let tokenExpiry = store.state.auth.tokenExpiry;

	// if (serverHost.includes("localhost") || serverHost.includes("127.0.0.1")) {
	// 	currentTime = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString();
	// 	tokenExpiry = new Date(store.state.auth.tokenExpiry).toISOString();
	// }

	// // check if token is expired
	// if (moment(currentTime).isSameOrAfter(tokenExpiry)) {
	// 	store.commit("auth/setIsTokenExpired");
	// }

	if (to.meta.requiresAuth && (!store.state.auth.isAuthenticated || store.state.auth.isTokenExpired)) {
		const targetPath = to.fullPath || to.path;
		if (targetPath && targetPath !== "/" && targetPath !== "/validation") {
			store.commit("auth/setRedirectLink", targetPath);
			sessionStorage.setItem("redirectLink", targetPath);
		}

		if (store.state.auth.currentOrganisation && store.state.auth.currentOrganisation.id && typeof sessionStorage !== 'undefined') {
			sessionStorage.setItem("selectedOrgId", store.state.auth.currentOrganisation.id);
		}

		store.dispatch("auth/logout");
		return next();
	}

	// return next();
};
